var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditAllGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 14.0002C2.66602 13.632 2.96449 13.3335 3.33268 13.3335H12.666C13.0342 13.3335 13.3327 13.632 13.3327 14.0002C13.3327 14.3684 13.0342 14.6668 12.666 14.6668H3.33268C2.96449 14.6668 2.66602 14.3684 2.66602 14.0002Z",
    fill: "#009866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2752 2.116C9.3166 1.07461 11.005 1.07461 12.0464 2.11601L12.5513 2.62091C13.5927 3.66231 13.5927 5.35076 12.5513 6.39215L7.94727 10.9962C7.76232 11.1811 7.52705 11.3076 7.27075 11.3599L4.26836 11.9718C3.33199 12.1626 2.50477 11.3355 2.69559 10.3991L3.30747 7.3966C3.3597 7.14029 3.48617 6.905 3.67114 6.72004L8.2752 2.116ZM11.1036 3.05882C10.5829 2.53812 9.7387 2.53812 9.21801 3.05882L8.94357 3.33325L11.3341 5.72377L11.6085 5.44934C12.1292 4.92864 12.1292 4.08442 11.6085 3.56372L11.1036 3.05882ZM5.61023 6.66657L8.00076 4.27605L10.3913 6.66657L8.00076 9.05709L5.61023 6.66657ZM4.66742 7.60938L4.61395 7.66285L4.00207 10.6653L7.00446 10.0534L7.05794 9.9999L4.66742 7.60938Z",
    fill: "#009866"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAllGreen);
export default __webpack_public_path__ + "static/media/edit_all_green.7409c859cc7293f2c2182829fd2d732b.svg";
export { ForwardRef as ReactComponent };